import { createFileRoute, redirect } from '@tanstack/react-router';

import { BILLING_PRODUCT_PATH, COSTS_TAB } from '@/modules/billing-product/route';

// Caminho da 2ª aba no legado (`router.tsx:1832`): cai no hub com a aba de custos (`?tab=`, U42).
export const Route = createFileRoute('/_app/cadastro/gestao/produtos-cobranca/parametros-custos')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- redirect() é o contrato do TanStack Router.
    throw redirect({ to: BILLING_PRODUCT_PATH, search: { tab: COSTS_TAB }, replace: true });
  },
});
